/** `style` carries dimensions that vary per instance (bar heights in a chart
 *  placeholder, for example) and so cannot be a fixed utility class. */
export function Skeleton({
  className = "",
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return <div className={`skeleton ${className}`} style={style} />;
}

// Card-shaped placeholder for loading states.
export function SkeletonCard({ className = "" }: { className?: string }) {
  return (
    <div className={`neu p-5 sm:p-6 flex flex-col gap-4 ${className}`}>
      <div className="flex items-center justify-between">
        <Skeleton className="h-3.5 w-24" />
        <Skeleton className="h-9 w-9 rounded-xl" />
      </div>
      <Skeleton className="h-8 w-32" />
      <Skeleton className="h-3 w-full" />
    </div>
  );
}
